export enum DetailsPageTab {
  OFFERS = 'angebote',
  CREATE_OFFER = 'angebote-erstellen',
  DETAILS = 'details',
  SLIP = 'proposal-slip',
  LEADING_OFFER = 'leading-offer',
  VERSION_HISTORY = 'version-history'
}
